import React from 'react'
import * as LucideIcons from 'lucide-react'

// Converts kebab-case icon name to PascalCase component name
const toPascal = (name) =>
  name.split('-').map((s) => s.charAt(0).toUpperCase() + s.slice(1)).join('')

/**
 * Drop-in replacement for <i data-lucide="name" style={{...}} />
 * Usage: <Icon name="arrow-right" style={{ width: 17, height: 17 }} />
 */
export function Icon({ name, style = {}, size, color, strokeWidth = 1.75, ...props }) {
  const Component = LucideIcons[toPascal(name)]
  if (!Component) {
    console.warn(`Icon not found: ${name}`)
    return null
  }
  const resolvedSize = size || style?.width || 24
  return (
    <Component
      size={resolvedSize}
      color={color}
      strokeWidth={strokeWidth}
      style={{ flexShrink: 0, ...style, width: style.width, height: style.height }}
      {...props}
    />
  )
}
